import dayjs from "dayjs";
import { supportsAdditionalInfoSales } from "../../../helpers/synchronizations";

export const TIPO_TITULO = 1;
export const TIPO_VENDA = 2;
export const MAX_FILE_MB = 10;
export const TEMPLATE_FILE_NAME = "Modelo_Informacoes_Adicionais.xlsx";

const ERP_BLING = 6; // Bling V1 não tem departamentos

export const formatDate = (value) => (value ? dayjs(value).format("DD/MM/YYYY") : "");
export const formatDateTime = (value) => (value ? dayjs(value).format("DD/MM/YYYY [às] HH:mm") : "");
export const formatMoney = (value) =>
  value === null || value === undefined
    ? ""
    : Number(value).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const formatNumber = (value) =>
  value === null || value === undefined ? "" : Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 4 });

export const plural = (n, singular, pluralForm) => `${n} ${n === 1 ? singular : pluralForm}`;

/**
 * O que muda por ERP: vendas (Nibo/Vehro não têm) e departamentos (Bling não tem). O resumo do
 * Backend (`suportaVendas`/`suportaDepartamentos`) prevalece; o código do ERP só cobre o primeiro
 * render, antes de o resumo chegar.
 */
export const getErpCapabilities = (erp, summary) => {
  const supportsSales = summary?.suportaVendas ?? supportsAdditionalInfoSales(erp);
  const supportsDepartments = summary?.suportaDepartamentos ?? Number(erp) !== ERP_BLING;
  const cadastros = [
    "categoria",
    "pessoa",
    supportsDepartments ? "departamento" : null,
    supportsSales ? "produto" : null,
  ].filter(Boolean);
  const cadastrosTexto =
    cadastros.length > 1 ? `${cadastros.slice(0, -1).join(", ")} e ${cadastros[cadastros.length - 1]}` : cadastros[0];
  return { supportsSales, supportsDepartments, cadastrosTexto };
};

// Mensagem das notifications do Backend (ex.: INFO_ADICIONAL_NAO_SUPORTADO), já que as chamadas
// desta seção suprimem o toast automático do interceptor.
export const notificationMessage = (data) => {
  const list = data?.notifications ?? data?.Notifications;
  return Array.isArray(list) && list.length > 0
    ? list.map((n) => n.message ?? n.Message).filter(Boolean).join(" ")
    : null;
};

// Com responseType "blob" o corpo de erro chega como Blob: lê o JSON para achar a mensagem.
export const blobErrorMessage = async (error) => {
  const data = error?.response?.data;
  if (!(data instanceof Blob)) return notificationMessage(data);
  try {
    return notificationMessage(JSON.parse(await data.text()));
  } catch {
    return null;
  }
};
